import { CarouselItem } from "@atoms/carousel-item";
import { Section } from "@atoms/section";
import { Typography } from "@atoms/typography";
import { ContactForm } from "@molecules/contact-form";
import { ContactFormData } from "@molecules/contact-form/types";
import { ContactSection } from "@organisms/contact-section";
import { LayoutTemplate } from "@templates/layout";
import React, { FC } from "react";
import { useTranslation } from "next-i18next";
import styled from "styled-components";

export type ContactTemplateProps = {
  onSubmit: (form: ContactFormData) => Promise<boolean>;
};

export const ContactTemplate: FC<ContactTemplateProps> = ({ onSubmit }) => {
  return (
    <LayoutTemplate page="contact">
      <CarouselItem
        imageStandard="/images/header_contact.jpg"
        imageWebp="/images/header_contact.webp"
      />
      <ContactArea onSubmit={onSubmit} />
    </LayoutTemplate>
  );
};

export const ContactArea: FC<{
  onSubmit: (form: ContactFormData) => Promise<boolean>;
}> = ({ onSubmit }) => {
  const { t } = useTranslation("contact");
  return (
    <Section>
      <Typography variant="title1">{t("title")}</Typography>
      <Grid>
        <ContactSection
          className="contact-form"
          form={ContactForm}
          onSubmit={onSubmit}
        />
        <div className="map-image">
          <img
            src="/images/feelinghome_office.jpg"
            alt="Oficina de FeelingHome"
          />
          <img
            src="//maps.googleapis.com/maps/api/staticmap?maptype=place&markers=Plaza+de+España+1,+Andratx,+Islas+Baleares,+España&hl=es&center=Plaza+de+España+1,+Andratx,+Islas+Baleares,+España&zoom=15&size=400x180&key=AIzaSyBg0xk8reNEDMogrjpF9COaq2kGRAecHBI&sensor=false"
            alt="Feeling Home Location"
          />
        </div>
        <div className="location">
          <Typography paragraph>{t("claim")}</Typography>
          <Typography paragraph>
            <a href="mailto:info@feelinghome.es">info@feelinghome.es</a>
          </Typography>
          <Typography paragraph>
            Plaza de España 1, Andratx, Islas Baleares, España, 07150
          </Typography>
        </div>
      </Grid>
    </Section>
  );
};

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1em;
  grid-template-areas:
    "contact-form"
    "map-image"
    "location";

  .contact-form {
    grid-area: contact-form;
    margin-bottom: 2em;
  }

  .location {
    grid-area: location;
    a {
      color: #000000;
    }
  }

  .map-image {
    grid-area: map-image;
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
    & img {
      display: block;
      max-width: 400px;
    }
  }

  @media (min-width: 48em) {
    grid-template-columns: 1.25fr 1fr;
    grid-template-areas:
      "contact-form contact-form"
      "map-image location";
  }

  @media (min-width: 75em) {
    grid-template-columns: 1fr 1fr;
    grid-template-areas:
      "map-image contact-form"
      "location contact-form";
  }
`;
